import React, { Component, PropTypes } from 'react';
import { Slider } from 'material-ui';
import FormFieldContainer from './FormFieldContainer';
import { Units } from 'Css';

class SliderChooser extends Component {
  static propTypes = {
    selected: PropTypes.number,
    title: PropTypes.string,
    onChange: PropTypes.func
  };

  handleChange = (event, value) => {
    const { onChange, selected } = this.props;
    if (value !== selected && onChange) {
      onChange(value);
    }
  };

  render() {
    const { title, selected, ...other } = this.props;
    return (
      <FormFieldContainer title={title}>
        <Slider
          name="slider"
          style={{ marginBottom: Units.base, marginTop: Units.base }}
          defaultValue={selected}
          {...other}
          onChange={this.handleChange}
        />
      </FormFieldContainer>
    );
  }
}

export default SliderChooser;



// WEBPACK FOOTER //
// ./src/js/components/Store/Editor/SliderChooser.js